import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { TreeProgramTopHeader } from 'components/common';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { FinishDateFuturePotentialDelayDriversWrapper } from 'components/widgets/FinishDateFuturePotentialDelayDrivers/FinishDateFuturePotentialDelayDriversWrapper';
import { FinishDatePredictionCompletionPlanWrapper } from 'components/widgets/FinishDatePredictionCompletionPlan/FinishDatePredictionCompletionPlanWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { FinishDateOverallSummary } from 'components/widgets/FinishDateOverallSummary/FinishDateOverallSummary';

export const FinishDatePredictionPage = () => {
    useFullStoryPageView({ pageName: excellenceAppsConfig.finishDatePrediction.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader pageTitle={excellenceAppsConfig.finishDatePrediction.title} />
                    </VersionSection>
                    <GlobalFilterButton />
                </VersionWrapper>

                <GlobalFilterComponent defaultValues={{ milestoneFragnet: null }}>
                    <MilestoneFragnetFilter name={'milestoneFragnet'} />
                </GlobalFilterComponent>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <FinishDateOverallSummary />
                    <FinishDatePredictionCompletionPlanWrapper />
                    <FinishDateFuturePotentialDelayDriversWrapper />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal
                queryKeys={['activityCompletionPlan', 'futurePotentialActivities', 'activityPrediction']}
            />
        </PageContainer>
    );
};
